import { AnalyticsService } from '@core/services/app/analytics.service';

/**
 * Generic logger utility that logs to both console and Jitsu
 * Usage: logToJitsu(analyticsService, 'info', 'my_label', 'My message', { key: 'value' })
 */
export function logToJitsu(
  analyticsService: AnalyticsService | null | undefined,
  level: 'info' | 'warn' | 'error' | 'debug',
  label: string,
  message: string,
  data?: Record<string, any>,
): void {
  // Log to console
  switch (level) {
    case 'error':
      console.error(message, data || '');
      break;
    case 'warn':
      console.warn(message, data || '');
      break;
    case 'debug':
    case 'info':
    default:
      console.log(message, data || '');
      break;
  }

  // Log to Jitsu (only if analyticsService is provided)
  if (analyticsService) {
    analyticsService.log({
      level,
      label,
      message: {
        text: message,
        ...data,
      },
    });
  }
}
